import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import HeadingItem from '@dashboard/components/HeadingItem';
import { usePreview } from '@dashboard/context/PreviewContext';
import clsx from 'clsx';
import Button from '@dashboard/components/Button';
import {
  ArrowPathIcon,
  ArrowTopRightOnSquareIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';
import usePage from '@dashboard/hooks/usePage';
import getCheckoutUrl from '@dashboard/services/getCheckoutUrl';
import Spinner from '@/dashboard/components/Spinner';

const PagePreviewNavigation = ({ setPreviewKey }) => {
  const { page, isRefetching } = usePage();
  const [previewState] = usePreview();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.includes('/test')) {
      setPreviewKey();
    }
  }, [location]);

  const isCheckoutPreview = previewState.type === 'checkout';
  const isTestCheckoutPreview = previewState.type === 'test-checkout';
  const isCheckoutConfirmationPreview = previewState.type === 'confirmationCheckoutMessage';

  const showReload = isTestCheckoutPreview;
  const showSavingState = isCheckoutPreview || isCheckoutConfirmationPreview;

  const checkoutUrl = getCheckoutUrl(page, page.seller);

  return (
    <div className="flex justify-between ml-px py-4 z-10 relative items-center h-16">
      <div className="mr-auto flex items-center">
        <HeadingItem>Preview</HeadingItem>

        {/* add external link to open current variant in preview new tab */}
        {page.usageType === 'hosted' && isCheckoutPreview && (
          <Button
            size="small"
            appearance="light"
            href={checkoutUrl}
            target="_blank"
            className={clsx('ml-2')}
          >
            <ArrowTopRightOnSquareIcon className="h-4 w-4" />
          </Button>
        )}
      </div>

      <div className="flex">
        {showReload && (
          <div className="">
            <Button
              size="small"
              appearance="light"
              className={clsx('gap-x-1 ml-4')}
              onClick={() => setPreviewKey()}
            >
              <ArrowPathIcon className="h-4 w-4" />
              Reload
            </Button>
          </div>
        )}

        {showSavingState && (
          <>
            {isRefetching ? (
              <div className="flex justify-end items-center text-gray-500 text-sm">
                <span className="mr-1">Saving</span>
                <Spinner size="small" />
              </div>
            ) : (
              <div className="flex justify-end items-center text-gray-500 text-sm">
                <span className="mr-1">Saved</span>
                <CheckCircleIcon className="h-5 w-5 text-green-300" />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PagePreviewNavigation;
